//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
    props:{
        formLabel:Array,
        form:Object,
        inline:Boolean
    },
    data(){

    }
}
